export default {
  maintenance_title:
    'Acuity Insights is currently down for scheduled maintenance.',
  maintenance_message:
    'We will be back up shortly. Thank you for your patience.'
};
